import { render, staticRenderFns } from "./searchproject.vue?vue&type=template&id=1b649bb7&scoped=true&"
import script from "./searchproject.vue?vue&type=script&lang=js&"
export * from "./searchproject.vue?vue&type=script&lang=js&"
import style0 from "./searchproject.vue?vue&type=style&index=0&id=1b649bb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b649bb7",
  null
  
)

export default component.exports